import { BaseModel } from '../../../../../../core/_base/crud';

    export class KhoDeNghiXuatKhoPage extends BaseModel {

        static NUMBER_DEFAULT = 0;
        static DEFAULT_NPSDNXK_KHSX = "NPSDNXK_KHSX";

        IdDn : number
        Sophieu : string
        IdPb : number
        BoPhanYeuCau : string
        Ngayxuat : string
        Nguoitao : number
        TenNguoitao : string
        Ngaytao : string
        Nguoisua : number
        Ngaysua : string
        Tinhtrang : string
        DescTinhTrang : string
        Ghichu : string
        Nguoiduyet : number
        TenNguoiduyet : string
        Ngayduyet : string
        Lydokhongduyet : string
        ChiTiet: KhoDeNghiXuatKhoPageChiTiet[]
        Enable_DaNhanTatCa : boolean
        LoaiPhieu: number
        TenLoaiPhieu: string
        ChoDuyet : number
        ChoDong : number
		ThamChieus: any[]
        Lydocode: string
        Lydo: string
        ChungTuKemTheo: boolean
        TenSoChungTu: string
        SupplierId: number
        SupplierCode: string
        SupplierName: string
        Receiver: string
        AddressReceiveProduct: string
        MaLoaiPhieu: string
        clear() {
            this.IdDn = 0;
            this.Sophieu = '';
            this.IdPb = 0;
            this.BoPhanYeuCau = '';
            this.Ngayxuat = '';
            this.Nguoitao = 0;
            this.TenNguoitao = '';
            this.Ngaytao = '';
            this.Nguoisua = 0;
            this.Ngaysua = '';
            this.Tinhtrang = '';
            this.DescTinhTrang = '';
            this.Ghichu = '';
            this.Nguoiduyet = 0;
            this.TenNguoiduyet = '';
            this.Ngayduyet = '';
            this.Lydokhongduyet = '';
            this.ChiTiet = [];
            this.Enable_DaNhanTatCa = false;
            this.LoaiPhieu = 0;
            this.TenLoaiPhieu = '';
            this.ChoDong = 0;
            this.ChoDuyet = 0;
			this.ThamChieus = [];
            this.Lydocode = ""
            this.Lydo = ""
            this.ChungTuKemTheo = false;
            this.TenSoChungTu = "";
            this.SupplierId = 0
            this.SupplierCode = ""
            this.SupplierName = ""
            this.Receiver = ""
            this.AddressReceiveProduct = ""
            this.MaLoaiPhieu = ""
        }
        copy(item:KhoDeNghiXuatKhoPage){
            this.IdDn =  item.IdDn;
            this.Sophieu = item.Sophieu;
            this.IdPb = item.IdPb;
            this.BoPhanYeuCau = item.BoPhanYeuCau;
            this.Ngayxuat = item.Ngayxuat;
            this.Nguoitao = item.Nguoitao;
            this.TenNguoitao = item.TenNguoitao;
            this.Ngaytao = item.Ngaytao;
            this.Nguoisua = item.Nguoisua;
            this.Ngaysua = item.Ngaysua;
            this.Tinhtrang = item.Tinhtrang;
            this.DescTinhTrang = item.DescTinhTrang;
            this.Ghichu = item.Ghichu;
            this.Nguoiduyet = item.Nguoiduyet;
            this.TenNguoiduyet = item.TenNguoiduyet;
            this.Ngayduyet = item.Ngayduyet;
            this.Lydokhongduyet = item.Lydokhongduyet;
            this.ChiTiet = item.ChiTiet;
            this.Enable_DaNhanTatCa = item.Enable_DaNhanTatCa;
            this.LoaiPhieu = item.LoaiPhieu;
            this.TenLoaiPhieu = item.TenLoaiPhieu;
            this.ChoDong = item.ChoDong;
            this.ChoDuyet = item.ChoDuyet;
			this.ThamChieus = item.ThamChieus;
            this.Lydocode = item.Lydocode
            this.Lydo = item.Lydo
            this.ChungTuKemTheo = item.ChungTuKemTheo;
            this.TenSoChungTu = item.TenSoChungTu;
            this.SupplierId = item.SupplierId
            this.SupplierCode = item.SupplierCode
            this.SupplierName = item.SupplierName
            this.Receiver = item.Receiver
            this.AddressReceiveProduct = item.AddressReceiveProduct
            this.MaLoaiPhieu = item.MaLoaiPhieu
        }
    }
    export class KhoDeNghiXuatKhoPageChiTiet extends BaseModel {
        IdCtdn : number
        IdDn : number
        IdHh : number
        IdKh: number
        MaHH : string
        QuyCach : string
        TenHH : string
        Soluong : number
        TextQuiDoiDVT: string
        SoLuongQuiDoi: number
        MucDichSuDung : string
        NguonPhatSinh : string
        NgayCan : string
        Dvt : number
        DvtQuiDoi : number
        TenDvt : string
        GhiChu : string
        DatHangId : number
        DatHangCtId: number
        DatHangSoPhieu : string
        MaKH: string
        TenKH: string
        isError: boolean
        messageError: string
        DaLapPhieuXuatKho: boolean
        XuLy: DM_DuyetChiTiet
        Enable_XacNhan: boolean
        BPDN: number
        TenBPDN : string
        BPSD: number
        TenBPSD: string
        SoLo: string
        SoMay: string
        SLThucXuat : number
        IsEnable_Duyet : boolean
        IsVisible_Duyet : boolean
        NguonPhatSinhId : number
        NguonPhatSinhType : string
        IsChoPassKhan : boolean
        MaSub : string
        TongTonDuocXuat: number
        TongTonKhongDuocXuat: number
        TongDuKienXuatTrongNgay: number
        IdPhieuDHB: number
        SoPhieuDHB: string
		//ListMachineCode: string[]
		SoMayArr: string[]
        ListHH: any[]
        NewBPSD: number
        NameNewBPSD: string
        searchNewPSD: string
        listNewBPSD: any[]
        DoiTuongTHCP: number
        TenDoiTuongTHCP: string
        SXSMArr: string[]
        SXSM: string
        NSX: string
        HSD: string
        MaThung: string
        NSXArr: string[]
        HSDArr: string[]
        MaThungArr: string[]
        OptionsSoMay: string[]
        OptionsSMSX: string[]
        OptionsNSX: string[]
        OptionsHSD: string[]
        OptionsMaThung: string[]
        ProductDisabled: boolean
        clear() {
            this.IdCtdn = 0;
            this.IdDn = 0;
            this.IdHh = 0;
            this.IdKh = 0;
            this.MaHH = '';
            this.QuyCach = '';
            this.TenHH = '';
            this.TextQuiDoiDVT = '';
            this.Soluong = 0;
            this.SoLuongQuiDoi = 0;
            this.MucDichSuDung = '';
            this.NguonPhatSinh = '';
            this.NgayCan = '';
            this.Dvt = 0;
            this.DvtQuiDoi = 0;
            this.TenDvt = '';
            this.GhiChu = '';
            this.isError = false;
            this.messageError = '';
            this.DatHangId = 0;
            this.DatHangCtId = 0;
            this.DatHangSoPhieu = '';
            this.MaKH = '',
            this.TenKH = '',
            this.DaLapPhieuXuatKho = false,
            this.XuLy = new DM_DuyetChiTiet(),
            this.Enable_XacNhan = false
            this.BPDN = 0
            this.BPSD = 0
            this.SoLo = ''
            this.SoMay = ''
            this.TenBPDN = ''
            this.TenBPSD = ''
            this.SLThucXuat = 0
            this.IsEnable_Duyet = false
            this.IsVisible_Duyet = false
            this.NguonPhatSinhId = 0
            this.NguonPhatSinhType = ""
            this.IsChoPassKhan = false
            this.MaSub = ""
            this.TongTonDuocXuat = 0
            this.TongTonKhongDuocXuat = 0
            this.TongDuKienXuatTrongNgay = 0
            this.IdPhieuDHB = 0
            this.SoPhieuDHB = ""
			//this.ListMachineCode = []
			this.SoMayArr = []
            this.ListHH = []
            this.NewBPSD = 0
            this.NameNewBPSD = ""
            this.searchNewPSD = ""
            this.listNewBPSD = []
            this.DoiTuongTHCP = 0
            this.TenDoiTuongTHCP = ""
            this.SXSMArr = []
            this.SXSM = ''
            this.NSX = ''
            this.HSD = ''
            this.MaThung = ''
            this.NSXArr = []
            this.HSDArr = []
            this.MaThungArr = []
            this.OptionsSoMay = []
            this.OptionsSMSX= []
            this.OptionsNSX= []
            this.OptionsHSD= []
            this.OptionsMaThung= []
            this.ProductDisabled = false
        }
        copy(item:KhoDeNghiXuatKhoPageChiTiet){
            this.IdCtdn = item.IdCtdn;
            this.IdDn = item.IdDn;
            this.IdHh = item.IdHh;
            this.IdKh = item.IdKh;
            this.MaHH = item.MaHH;
            this.QuyCach = item.QuyCach;
            this.TenHH = item.TenHH;
            this.Soluong = item.Soluong;
            this.SoLuongQuiDoi = item.SoLuongQuiDoi;
            this.TextQuiDoiDVT = item.TextQuiDoiDVT;
            this.MucDichSuDung = item.MucDichSuDung;
            this.NguonPhatSinh = item.NguonPhatSinh;
            this.NgayCan = item.NgayCan;
            this.Dvt = item.Dvt;
            this.DvtQuiDoi = item.DvtQuiDoi;
            this.TenDvt = item.TenDvt;
            this.GhiChu = item.GhiChu;
            this.isError = item.isError;
            this.messageError = item.messageError;
            this.DatHangId = item.DatHangId;
            this.DatHangCtId = item.DatHangCtId;
            this.DatHangSoPhieu = item.DatHangSoPhieu;
            this.MaKH = item.MaKH,
            this.TenKH = item.TenKH,
            this.DaLapPhieuXuatKho = item.DaLapPhieuXuatKho,
            this.XuLy = item.XuLy,
            this.Enable_XacNhan = item.Enable_XacNhan
            this.BPDN = item.BPDN
            this.BPSD = item.BPSD
            this.SoLo = item.SoLo
            this.SoMay = item.SoMay
            this.TenBPDN = item.TenBPDN
            this.TenBPSD = item.TenBPSD
            this.SLThucXuat = item.SLThucXuat
            this.IsEnable_Duyet = item.IsEnable_Duyet
            this.IsVisible_Duyet = item.IsVisible_Duyet
            this.NguonPhatSinhId = item.NguonPhatSinhId
            this.NguonPhatSinhType = item.NguonPhatSinhType
            this.IsChoPassKhan = item.IsChoPassKhan
            this.MaSub = item.MaSub
            this.TongTonDuocXuat = item.TongTonDuocXuat
            this.TongTonKhongDuocXuat = item.TongTonKhongDuocXuat
            this.TongDuKienXuatTrongNgay = item.TongDuKienXuatTrongNgay
            this.IdPhieuDHB = item.IdPhieuDHB
            this.SoPhieuDHB = item.SoPhieuDHB
			//this.ListMachineCode = item.ListMachineCode;
			this.SoMayArr = item.SoMayArr
			this.ListHH = item.ListHH
            this.NewBPSD = item.NewBPSD
            this.NameNewBPSD = item.NameNewBPSD
            this.searchNewPSD = item.searchNewPSD
            this.listNewBPSD = item.listNewBPSD
            this.DoiTuongTHCP = item.DoiTuongTHCP
            this.TenDoiTuongTHCP = item.TenDoiTuongTHCP
            this.SXSMArr = item.SXSMArr
            this.SXSM = item.SXSM
            this.NSX = item.NSX
            this.HSD = item.HSD
            this.MaThung = item.MaThung
            this.NSXArr = item.NSXArr
            this.HSDArr = item.HSDArr
            this.MaThungArr = item.MaThungArr
            this.OptionsSoMay = item.OptionsSoMay
            this.OptionsSMSX= item.OptionsSMSX
            this.OptionsNSX= item.OptionsNSX
            this.OptionsHSD= item.OptionsHSD
            this.OptionsMaThung= item.OptionsMaThung
            this.ProductDisabled = item.ProductDisabled
        }
    }

    export class DM_DuyetChiTiet extends BaseModel {
        Id : number
        PhieuDeNghi : number
        PhieuDeNghiCT : number
        ListXacNhanNhanHang  = []
        NguoiDuyet : number
        TenNguoiDuyet : string
        NgayDuyet : string
        LoaiThaoTac : string
        LyDo : string
        NgayDuyetDate: Date
        TenLoaiThaoTac: string
        CoKetQuaDuyet : boolean
        clear(){
            this.Id = 0
            this.PhieuDeNghi = 0
            this.PhieuDeNghiCT = 0
            this.ListXacNhanNhanHang  = []
            this.NguoiDuyet = 0
            this.TenNguoiDuyet = ''
            this.NgayDuyet = ''
            this.LoaiThaoTac = ''
            this.LyDo =''
            this.NgayDuyetDate = new Date()
            this.TenLoaiThaoTac = ''
            this.CoKetQuaDuyet = false
        }
    }


    export class ChiTietSoLuongTonModel extends BaseModel {
        Id : number
        MaKho : string
        TenKho : string
        SLDuocXuat : number
        SLKhongDuocXuat : number
        LyDoKhongDuocXuat : string
        POs: number[]
        POStr: string[]
        IsAccept: boolean
        SoLo: string
        NgayNhapKho: string
        clear(){
            this.Id = 0;
            this.MaKho = ''
            this.TenKho = ''
            this.SLDuocXuat = 0
            this.SLKhongDuocXuat = 0
            this.LyDoKhongDuocXuat = ""
            this.POs = []
            this.POStr = []
            this.IsAccept = false;
            this.SoLo = "";
            this.NgayNhapKho = ""
        }
        copy(item: ChiTietSoLuongTonModel){
            this.Id = item.Id
            this.MaKho =  item.MaKho
            this.TenKho = item.TenKho
            this.SLDuocXuat = item.SLDuocXuat
            this.SLKhongDuocXuat = item.SLKhongDuocXuat
            this.LyDoKhongDuocXuat = item.LyDoKhongDuocXuat
            this.POs = item.POs
            this.POStr = item.POStr
            this.IsAccept = item.IsAccept
            this.SoLo = item.SoLo
            this.NgayNhapKho = item.NgayNhapKho
        }
    }

    export class LichSuXuatKhoModel extends BaseModel{
        MaHH: string
        TenHH: string
        DVT: string
        SoLo: string
        SLXuat: number
        NgayXuatKho: string
        SoPhieuXK: string
        TrangThaiXK: string
        KhoXuat: string
        ViTriXuat: string
        SoMay: string
        MaSubLo: string
        CodeTrangThai: string
        clear(){
            this.MaHH = ""
            this.TenHH = ""
            this.DVT = ""
            this.SoLo = ""
            this.SLXuat = 0
            this.NgayXuatKho = ""
            this.SoPhieuXK = ""
            this.TrangThaiXK = ""
            this.KhoXuat = ""
            this.ViTriXuat = ""
            this.SoMay = ""
            this.MaSubLo = ""
            this.CodeTrangThai = ""
        }

        copy(item: LichSuXuatKhoModel){
            this.MaHH = item.MaHH
            this.TenHH = item.TenHH
            this.DVT = item.DVT
            this.SoLo = item.SoLo
            this.SLXuat = item.SLXuat
            this.NgayXuatKho = item.NgayXuatKho
            this.SoPhieuXK = item.SoPhieuXK
            this.TrangThaiXK = item.TrangThaiXK
            this.KhoXuat = item.KhoXuat
            this.ViTriXuat = item.ViTriXuat
            this.SoMay = item.SoMay
            this.MaSubLo = item.MaSubLo
            this.CodeTrangThai = item.CodeTrangThai
        }
    }

    export class KeHoachGiaoHangFilterChoGiao extends BaseModel{
        Id : number
        Id_HH : number
        TenHH : string
        MaHH : string
        SoLuong : number
        SoLuongDaGiao : number
        TenDVT : string
        Id_KH : number
        TenKH : string
        MaKH : string
        NgayGiaoHang : string
        NgayGiaoHangTo : string
        NgayGiaoHangTu : string
        NgayGiaoHangDen : string
        ThuocForecast : boolean
        STT : number
        TrangThai : string
        Id_DHB : number
        Id_CT: number
        SoPhieu_DHB : string
        DVT: number
        QuyCach: string

        clear(){
            this.Id  = 0
            this.Id_HH  = 0
            this.TenHH  = ""
            this.MaHH  = ""
            this.SoLuong  = 0
            this.SoLuongDaGiao  = 0
            this.TenDVT  = ""
            this.Id_KH  = 0
            this.TenKH  = ""
            this.MaKH  = ""
            this.NgayGiaoHang  = ""
            this.NgayGiaoHangTo  = ""
            this.NgayGiaoHangTu  = ""
            this.NgayGiaoHangDen  = ""
            this.ThuocForecast = false
            this.STT  = 0
            this.TrangThai  = ""
            this.Id_DHB  = 0
            this.SoPhieu_DHB  = ""
            this.DVT = 0
            this.QuyCach = ""
            this.Id_CT = 0
        }

        copy(item: KeHoachGiaoHangFilterChoGiao){
            this.Id  = item.Id
            this.Id_HH  = item.Id_HH
            this.TenHH  = item.TenHH
            this.MaHH  = item.MaHH
            this.SoLuong  = item.SoLuong
            this.SoLuongDaGiao  = item.SoLuongDaGiao
            this.TenDVT  = item.TenDVT
            this.Id_KH  = item.Id_KH
            this.TenKH  = item.TenKH
            this.MaKH  = item.MaKH
            this.NgayGiaoHang  = item.NgayGiaoHang
            this.NgayGiaoHangTo  = item.NgayGiaoHangTo
            this.NgayGiaoHangTu  = item.NgayGiaoHangTu
            this.NgayGiaoHangDen  = item.NgayGiaoHangDen
            this.ThuocForecast = item.ThuocForecast
            this.STT  = item.STT
            this.TrangThai  = item.TrangThai
            this.Id_DHB  = item.Id_DHB
            this.SoPhieu_DHB  = item.SoPhieu_DHB
            this.DVT = item.DVT
            this.QuyCach = item.QuyCach
            this.Id_CT = item.Id_CT
        }
    }

    export class CONFIGURATION { 
        static CODE_FORM        = "DNXK";
        static ENABLE_REQUIRED  = { key: 'XUATBPSD', value: 'DIVISION'};
        static OTHER_REASONS    = { key : 'KHAC', value : 'Khác'};
        static OTHER_REQUIRED   = { key : 'KHAC', value : 'LYDOKHAC'};
        static SAVE_TEMP        = 0;
        static SAVE_NEW         = 1;
        static SAVE_EDIT        = 2;
        static NAVIGATE_UPDATE  = "/de-nghi-xuat-kho/chinh-sua/"; 
        static NAVIGATE_ADD     = "/de-nghi-xuat-kho/them-moi/"; 
        static XUATTRANCC       = { key: 'XUATTRANCC', value: 'Xuất trả nhà cung cấp'}; 
        static BPSD_REQUIRED    = { key: 'BPSD', value: '1'};
        static REASON_FOR_PRODUCTION_ACTIVITIES = { key: "SANXUAT", field: 'OBJTHCP'};
        static SUPPLIER_RETURN_TYPE = "7_XUATTRANCCVAKHAC";
        static REASON_FOR_SUPPLIER_RETURN = "XUATTRANCC";
        static EXPORT_TO_USE_TYPE = "1_BOPHANSUDUNG";
        static REASON_EXPORT_TO_PRODUCTION = "SANXUAT";
        static REQUEST_EXPORT_TYPE_DEFAULT = "1";
        static NOT_CHECK_CHANGE = false;
        static CLOSE_POPUP = true;
    }

    export class ERROR_MESSAGES{
        static ERROR_CONNECT_API        = "Lỗi: Không thể lấy danh sách lý do xuất!";
        static ERROR_LIST_EMPTY         = "Lỗi: Danh sách lý do xuất trống";
        static ERROR_DETAILS_EMPTY      = "Vui lòng thêm ít nhất một hàng hóa vào danh sách chi tiết.";
        static ERROR_DETAILS_INVALID    = "Vui lòng chỉnh sửa dữ liệu lỗi trước khi lưu tại dòng: ";
        static ERROR_PRODUCT_DISABLED   = "Vui lòng xóa hàng hóa đã bị xóa khỏi hệ thống tại dòng: ";
    }

    export class SUCCESS{
        static UPDATE_SUCCESS = "Phiếu đề nghị xuất kho _sophieu_ cập nhật thành công.";
    }

    export class DEFAULT {
        static TABLE_COLUMNS = [
            {
                stt: 1,
                name: "#",
                displayName: "#",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 2,
                name: "MAHH",
                displayName: "Mã hàng",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 3,
                name: "TENHH",
                displayName: "Tên hàng",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 4,
                name: "QUYCACH",
                displayName: "Quy cách",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "SOLUONG",
                displayName: "SL",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 5,
                name: "DONVITINH",
                displayName: "Đơn vị tính",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "SOLUONGTHUCXUAT",
                displayName: "SL thực xuất",
                alwaysChecked: false,
                isShow: true,
            },
    
            {
                stt: 6,
                name: "BPDN",
                displayName: "Bộ phận đề nghị",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "BPSD",
                displayName: "Bộ phận sử dụng",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "NewBPSD",
                displayName: "Bộ phận sử dụng",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 7,
                name: "MUCDICHSUDUNG",
                displayName: "Mục đích sử dụng",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "SOLO",
                displayName: "Số lô",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "SOMAY",
                displayName: "Số máy",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 6,
                name: "SMSX",
                displayName: "Số mẻ/số xe",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 11,
                name: 'MATHUNG',
                displayName: 'Mã thùng (TP)',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 9,
                name: "NGAYCAN",
                displayName: "Ngày cần",
                alwaysChecked: false,
                isShow: true,
            },
            {
                stt: 10,
                name: 'MAKH',
                displayName: 'Mã KH',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'OBJTHCP',
                displayName: 'Đối tượng THCP',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'NSX',
                displayName: 'Ngày sản xuất',
                alwaysChecked: false,
                isShow: true
            },
            {
                stt: 11,
                name: 'HSD',
                displayName: 'Hạn sủ dụng',
                alwaysChecked: false,
                isShow: true
            },
        ];
        static TABLE_EXTEND_COLUMNS = [
            {
                stt: 99,
                name: "ACTIONS",
                displayName: "Thao tác",
                alwaysChecked: true,
                isShow: true,
            },
        ];
        static LIST_STATUS = [
            {
                id: 1,
                name: "Đang soạn thảo",
                value: "KHOPDNXK_LUUNHAP",
            },
            {
                id: 2,
                name: "Chờ duyệt",
                value: "KHOPDNXK_CHODUYET",
            },
            {
                id: 3,
                name: "Bị trả lại",
                value: "KHOPDNXK_BITRALAI",
            },
            {
                id: 4,
                name: "Hoàn tất",
                value: "KHOPDNXK_HOANTAT",
            },
            {
                id: 5,
                name: "Đã hủy",
                value: "KHOPDNXK_DAHUY",
            },
            {
                id: 6,
                name: "Chờ xuất kho",
                value: "KHOPDNXK_CHOXUATKHO",
            },
            {
                id: 7,
                name: "Đã xóa",
                value: "KHOPDNXK_DAXOA",
            },
        ];
    }


